import { Channel } from 'Listrak.Customer.Segmentation.Api.V2.Client';
import channelFormatter from 'utils/channel-formatter/channelFormatter';

export default function (audienceCount: number, listName: string, channelContext: Channel): string {
  let subscriberText = (!['TikTokAudience'].includes(channelContext))
    ? (audienceCount == 1 ? 'subscriber' : 'subscribers')
    : (audienceCount == 1 ? 'contact' : 'contacts');

  let subscription = listName
    ? ' to ' + listName
    : channelContext
      ? ' to ' + channelFormatter(channelContext)
      : '';

  return `${subscriberText}${subscription}`;
}
